import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar"
import { AdminSidebar } from "@/components/AdminSidebar"
import { CouncilSidebar } from "@/components/CouncilSidebar"
import { useLocation } from "react-router-dom"

interface LayoutProps {
  children: React.ReactNode
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation()

  // Check if we're on a council-specific route (including detail pages)
  const isCouncilRoute = location.pathname.startsWith("/council/")
  const SidebarComponent = isCouncilRoute ? CouncilSidebar : AdminSidebar

  return (
    <SidebarProvider>
      <div className="flex h-screen min-h-screen w-full bg-background">
        <SidebarComponent />
        <main className="flex min-h-0 flex-1 flex-col">
          <header className="sticky top-0 z-20 border-b border-border bg-background p-4">
            <SidebarTrigger />
          </header>
          <div className="min-h-0 flex-1 overflow-y-auto p-6">{children}</div>
        </main>
      </div>
    </SidebarProvider>
  )
}
